(function() {
  var urls = window.themeAssetUrls || {};
  var scriptPromises = {};
  var stylePromises = {};
  var nativeSwiper = window.Swiper;

  function loadScriptOnce(src, key) {
    if (!src) return Promise.reject(new Error('missing script src'));
    var cacheKey = key || src;
    if (scriptPromises[cacheKey]) return scriptPromises[cacheKey];

    var existing = document.querySelector('script[data-tv-asset-key="' + cacheKey + '"]');
    if (existing) {
      scriptPromises[cacheKey] = Promise.resolve(existing);
      return scriptPromises[cacheKey];
    }

    scriptPromises[cacheKey] = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.setAttribute('data-tv-asset-key', cacheKey);
      script.onload = function() { resolve(script); };
      script.onerror = function() { reject(new Error('failed to load ' + cacheKey)); };
      document.head.appendChild(script);
    });
    return scriptPromises[cacheKey];
  }

  function loadStyleOnce(href, key) {
    if (!href) return Promise.reject(new Error('missing stylesheet href'));
    var cacheKey = key || href;
    if (stylePromises[cacheKey]) return stylePromises[cacheKey];

    var existing = document.querySelector('link[data-tv-asset-key="' + cacheKey + '"]');
    if (existing) {
      stylePromises[cacheKey] = Promise.resolve(existing);
      return stylePromises[cacheKey];
    }

    stylePromises[cacheKey] = new Promise(function(resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-tv-asset-key', cacheKey);
      link.onload = function() { resolve(link); };
      link.onerror = function() { reject(new Error('failed to load ' + cacheKey)); };
      document.head.appendChild(link);
    });
    return stylePromises[cacheKey];
  }

  function loadWhenIntersecting(target, callback, options) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      callback(el);
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        callback(el);
      });
    }, options || { rootMargin: '320px 0px' });
    observer.observe(el);
  }

  function loadOnIntent(target, callback, events) {
    var el = typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;
    var eventNames = events || ['pointerdown', 'focusin'];
    var done = false;
    var run = function() {
      if (done) return;
      done = true;
      eventNames.forEach(function(eventName) {
        el.removeEventListener(eventName, run, true);
      });
      callback(el);
    };
    eventNames.forEach(function(eventName) {
      el.addEventListener(eventName, run, { capture: true, passive: true });
    });
  }

  function loadSwiper() {
    if (window.Swiper && window.Swiper.__tvProxy !== true) {
      return Promise.resolve(window.Swiper);
    }
    return loadScriptOnce(urls.swiper, 'swiper').then(function() {
      nativeSwiper = window.Swiper;
      return window.Swiper;
    });
  }

  function SwiperProxy() {
    var args = Array.prototype.slice.call(arguments);
    var queuedCalls = [];
    var instance = null;
    var proxy = {
      __tvSwiperProxyInstance: true,
      thumbs: {
        swiper: {
          changeDirection: function() {
            queuedCalls.push(['thumbs.swiper.changeDirection', arguments]);
          }
        }
      },
      on: function() {
        queuedCalls.push(['on', arguments]);
        return proxy;
      },
      destroy: function() {
        queuedCalls.push(['destroy', arguments]);
        return proxy;
      },
      slideToLoop: function() {
        queuedCalls.push(['slideToLoop', arguments]);
        return proxy;
      }
    };

    var start = function() {
      loadSwiper().then(function(SwiperCtor) {
      if (!SwiperCtor || SwiperCtor.__tvProxy === true || instance) return;
      instance = new (Function.prototype.bind.apply(SwiperCtor, [null].concat(args)))();
      queuedCalls.forEach(function(item) {
        if (item[0] === 'thumbs.swiper.changeDirection' && instance.thumbs && instance.thumbs.swiper) {
          instance.thumbs.swiper.changeDirection.apply(instance.thumbs.swiper, item[1]);
          return;
        }
        if (typeof instance[item[0]] === 'function') {
          instance[item[0]].apply(instance, item[1]);
        }
      });
      }).catch(function() {});
    };

    var target = typeof args[0] === 'string' ? document.querySelector(args[0]) : args[0];
    if (target) {
      loadWhenIntersecting(target, start);
    } else {
      start();
    }

    return proxy;
  }
  SwiperProxy.__tvProxy = true;

  if (!nativeSwiper) {
    window.Swiper = SwiperProxy;
  }

  function loadMasonry() {
    return loadScriptOnce(urls.masonry, 'masonry');
  }

  if (window.jQuery && !window.jQuery.fn.masonry) {
    window.jQuery.fn.masonry = function(options) {
      var collection = this;
      loadWhenIntersecting(collection[0], function() {
        loadMasonry().then(function() {
          if (window.jQuery.fn.masonry && window.jQuery.fn.masonry.__tvProxy !== true) {
            window.jQuery(collection).masonry(options);
          }
        }).catch(function() {});
      });
      return collection;
    };
    window.jQuery.fn.masonry.__tvProxy = true;
  }

  window.themeAssetLoader = {
    loadScriptOnce: loadScriptOnce,
    loadStyleOnce: loadStyleOnce,
    loadWhenIntersecting: loadWhenIntersecting,
    loadOnIntent: loadOnIntent,
    loadSwiper: loadSwiper,
    loadMasonry: loadMasonry
  };
})();
